import {
  GeographyResponse,
  GetLogoBankResponse,
  MasterProcesData,
  TransportationTypeItems,
} from "services/interface";
import styled from "@emotion/styled";
import { FormInstance, Row, Select } from "antd";
import { FC } from "react";
import ShippingDescriptionForm from "./ShippingDescriptionForm";

const { Option } = Select;

interface MainCreateShippingProps {
  form: FormInstance;
  data: TransportationTypeItems[] | undefined;
  dataGeography: GeographyResponse | undefined;
  edit?: boolean;
  province_id?: number | undefined | null;
  district_id?: number | undefined | null;
  is_free: boolean;
}

const MainCreateShipping: FC<MainCreateShippingProps> = ({
  form,
  data,
  dataGeography,
  edit,
  province_id,
  district_id,
  is_free,
}) => {
  return (
    <FormWrapper>
      <ShippingDescriptionForm
        data={data}
        is_active={true}
        dataGeography={dataGeography}
        edit={edit}
        form={form}
        province_id={province_id}
        district_id={district_id}
        is_free={is_free}
      />
    </FormWrapper>
  );
};

export default MainCreateShipping;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
